export const SUPPORT_EMAIL = "support@clearvoyage.com";

export const APP_NAME = "ClearVoyage Crew";